import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/_store'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import NoAuthLayout from '@/layout/NoAuthLayout'
import ActivityIndex from '@/views/Activity/index'
import DocumentIndex from '@/views/Documents/index'
import CustomerIndex from '@/views/Customers/index'
import LocationIndex from '@/views/Locations/index'
import FormsIndex from '@/views/Locations'
import UserIndex from '@/views/Users/index'
import ServiceIndex from'@/views/ServiceDashboard'
import InspectionToursIndex from '@/views/InspectionTours'
import ReportIndex from '@/views/Report'
Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Main.vue'),
          meta: {requiresAuth: true}
        },
        {
          path: '/service',
          redirect: '/service/check',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: ServiceIndex,
          children: [
            {
              path: 'check',
              name: 'player_check',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/ServiceDashboard/Spielercheck/SpielerCheckController.vue'),
              meta: {requiresAuth: true, title: 'Spielercheck'}
            },
            {
              path:'/documents',
              redirect:'/documents/main',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: DocumentIndex,
              children:[
                {
                  path:'main',
                  name:'documents_view',
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component:() => import(/* webpackChunkName: "demo" */ './components/UploadField/main.vue'),
                  meta:{requiresAuth:true, title:'Dokumente'},
                  props: {url: process.env.VUE_APP_API_SERVER +'/api/documents', expanded: false}
                }
              ]
            },
            {
              path: 'protocols',
              name: 'protocols_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Protocols/list.vue'),
              meta: {requiresAuth: true, title: 'Protokollliste'}
            },
            {
              path: 'protocols/create',
              name: 'protocols_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Protocols/create.vue'),
              meta: {requiresAuth: true, title: 'Protokoll erstellen'}
            },
            {
              path: 'protocols/edit/:id',
              name: 'protocols_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Protocols/create.vue'),
              meta: {requiresAuth: true, title: 'Protokoll editieren'}
            },
            {
              path: '/activities',
              redirect: '/activities/list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: ActivityIndex,
              children: [
                {
                  path: 'list',
                  name: 'activities_list',
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component: () => import(/* webpackChunkName: "demo" */ './views/Activity/list.vue'),
                  meta: {requiresAuth: true, title: 'Spielerschutzmaßnahmen'}
                }
              ]
            },
            {
              path: '/tasks',
              redirect: '/tasks/list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: ActivityIndex,
              children: [
                {
                  path: 'list',
                  name: 'tasks_list',
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component: () => import(/* webpackChunkName: "demo" */ './views/Tasks/list.vue'),
                  meta: {requiresAuth: true, title: 'Aufgaben'}
                }
              ]
            },
            {
              path: '/inspectiontours',
              redirect: '/inspectiontours/list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: InspectionToursIndex,
              children: [
                {
                  path: 'list',
                  name: 'inspectiontours_list',
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component: () => import(/* webpackChunkName: "demo" */ './views/InspectionTours/list.vue'),
                  meta: {requiresAuth: true, title: 'Kontrollgangliste'}
                },
                {
                  path: 'show/:id',
                  name: 'inspectiontours_edit',
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component: () => import(/* webpackChunkName: "demo" */ './views/InspectionTours/show.vue'),
                  meta: {requiresAuth: true, title: 'Kontrollgang editieren'}
                }
              ]
            },
          ],
        },
        {
          path: '/customer',
          redirect: '/customer/list',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: CustomerIndex,
          children: [
            {
              path: 'list',
              name: 'customer_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Customers/list.vue'),
              meta: {requiresAuth: true, title: 'Organisationen'}
            },
            {
              path: 'create',
              name: 'customer_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Customers/create.vue'),
              meta: {requiresAuth: true, title: 'Organisation erstellen'}
            },
            {
              path: 'billing',
              name: 'customer_billing',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Customers/billing.vue'),
              meta: {requiresAuth: true, title: 'Vertragscenter'}
            },
            {
              path: 'edit/:id',
              name: 'customer_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Customers/edit.vue'),
              meta: {requiresAuth: true, title: 'Organisation editieren'}
            },
          ],
        },
        {
          path: '/oasiscerts',
          redirect: '/oasiscerts/dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: CustomerIndex,
          children: [
            {
              path: 'dashboard',
              name: 'oasis_dashboard',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/OasisCerts/Oasis.vue'),
              meta: {requiresAuth: true, title: 'OASIS Dashboard'}
            },
            {
              path: 'list',
              name: 'oasiscert_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/OasisCerts/list.vue'),
              meta: {requiresAuth: true, title: 'Zertifikatsliste'}
            },
            {
              path: 'create',
              name: 'oasiscert_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/OasisCerts/create.vue'),
              meta: {requiresAuth: true, title: 'Zertifikat hochladen'}
            },
            {
              path: 'edit/:id',
              name: 'oasiscert_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/OasisCerts/edit.vue'),
              meta: {requiresAuth: true, title: 'Zertifikate editieren'}
            },
          ],
        },
        {
          path: '/reports',
          redirect: '/reports/list',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: ReportIndex,
          children: [
            {
              path: 'list',
              name: 'report_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Report/list.vue'),
              meta: {requiresAuth: true, title: 'Berichte'}
            },
            {
              path: 'show/:id',
              name: 'report_show',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Report/show.vue'),
              meta: {requiresAuth: true, title: 'Bericht ansehen'}
            },
          ],
        },
        {
          path: '/locations',
          redirect: '/locations/list',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: LocationIndex,
          children: [
            {
              path: 'list',
              name: 'location_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Locations/list.vue'),
              meta: {requiresAuth: true, title: 'Standortliste'}
            },
            {
              path: 'create',
              name: 'location_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Locations/create.vue'),
              meta: {requiresAuth: true, title: 'Standort erstellen'}
            },
            {
              path: 'edit/:id',
              name: 'location_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Locations/edit.vue'),
              meta: {requiresAuth: true, title: 'Standort editieren'}
            },
          ],
        },
        {
          path:'/states',
          redirect:'/states/edit',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component:FormsIndex,
          children:[
            {
              path:'edit',
              name:'states_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component:() => import(/* webpackChunkName: "demo" */ './views/States/edit.vue'),
              meta:{requiresAuth:true, title:'Bundesländer'}
            }]
        },
        {
          path:'/socialconcepts',
          redirect:'socialconcepts/edit',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component:FormsIndex,
          children:[
            {
              path:'edit',
              name:'socialconcepts_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component:() => import(/* webpackChunkName: "demo" */ './views/Socialconcepts/edit.vue'),
              meta:{requiresAuth:true, title:'Sozialkonzepte und Maßnahmen'}
            }]
        },
        {
          path: '/forms',
          redirect: '/forms/list',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: FormsIndex,
          children: [
            {
              path: 'list',
              name: 'forms_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Forms/list.vue'),
              meta: {requiresAuth: true, title: 'Fragebogen Vorlagen'}
            },
            {
              path: 'create',
              name: 'forms_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Forms/create.vue'),
              meta: {requiresAuth: true, title: 'Fragebogen erstellen'}
            },
            {
              path: 'edit/:id',
              name: 'forms_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Forms/create.vue'),
              meta: {requiresAuth: true, title: 'Fragebogen editieren'}
            },
          ],
        },
        {
          path: '/users',
          redirect: '/users/list',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: UserIndex,
          children: [
            {
              path: 'list',
              name: 'user_list',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Users/list.vue'),
              meta: {requiresAuth: true, title: 'Benutzerliste'}
            },
            {
              path: 'create',
              name: 'user_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Users/create.vue'),
              meta: {requiresAuth: true, title: 'Benutzer erstellen'}
            },
            {
              path: 'invite',
              name: 'user_invite',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Users/invite.vue'),
              meta: {requiresAuth: true, title: 'Benutzer zu einer Organisation hinzufügen'}
            },
            {
              path: 'edit/:id',
              name: 'user_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Users/edit.vue'),
              meta: {requiresAuth: true, title: 'Benutzer editieren'}
            },
            {
              path: 'userdata',
              name: 'user_userdata',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Users/userdata.vue'),
              meta: {requiresAuth: true, title: 'Benutzerdaten'}
            },
            {
              path: 'profiles',
              name: 'user_profiles',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Profiles/edit.vue'),
              meta: {requiresAuth: true, title: 'Profile anzeigen und editieren'}
            },
            {
              path: 'profiles_create',
              name: 'user_profiles_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/Profiles/Details/create.vue'),
              meta: {requiresAuth: true, title: 'Profil erstellen'}
            },
            {
              path:'profiles_edit/:id',
              name:'user_profiles_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component:() => import(/* webpackChunkName: "demo" */ './views/Profiles/Details/edit.vue'),
              meta:{requiresAuth:true, title:'Profil anzeigen und editieren'}
            },
            {
              path: 'profiles_documents',
              name: 'user_profile_documents',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/ProfileDocuments/list.vue'),
              meta: {requiresAuth: true, title: 'Nachweise'}
            },
            {
              path: 'profiles_documents/:profile?',
              name: 'user_profile_documents_by_profile',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/ProfileDocuments/list.vue'),
              meta: {requiresAuth: true, title: 'Nachweise'}
            },
            {
              path: 'profiles_document_create/:profile?/:type?',
              name: 'user_profile_document_create',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "demo" */ './views/ProfileDocuments/create.vue'),
              meta: {requiresAuth: true, title: 'Nachweis erstellen'}
            },
            {
              path:'profiles_document_edit/:id',
              name:'user_profiles_document_edit',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component:() => import(/* webpackChunkName: "demo" */ './views/ProfileDocuments/edit.vue'),
              meta:{requiresAuth:true, title:'Nachweis anzeigen und editieren'}
            },
          ],
        },
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/forgotpassword',
          name: 'forgotpassword',
          component: () => import(/* webpackChunkName: "demo" */ './views/ForgotPassword.vue')
        },
        {
          path: '/forgotpassword/:token',
          name: 'resetpassword',
          component: () => import(/* webpackChunkName: "demo" */ './views/ResetPassword.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'profile_document_upload',
      component: NoAuthLayout,
      children: [
        {
          path: '/pd/:token',
          name: 'profile_document_upload',
          component: () => import(/* webpackChunkName: "demo" */ './views/ProfileDocumentUpload.vue')
        }
      ]
    }]});



router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('token');
  let retryCount = 0;

  function onRefresh() {
    store.dispatch('authentication/onRefresh').then(() => {
      store.dispatch('alert/clear')
      store.dispatch('loading/loadingIsFinished');
      next();
    })
        .catch(error => {
          //start retry
          retryCount += 1;
          store.dispatch('alert/warn', retryCount + '. Verbindungsversuch fehlgeschlagen. Nächster Verbindungsversuch in ' + retryCount * 3 + ' Sekunden. [' + error + ']')
          // add timer (retrycount * 2s) to wait for next retry
          setTimeout(function () {
            onRefresh()
          }, retryCount * 3000);
        });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (loggedIn) {
      if(!store.getters['authentication/isAuthenticated']) {
        store.dispatch('loading/isLoading');
        onRefresh();
      } else {
        next();
      }
    } else {
      next('/login')
    }
  } else {
    next(); // make sure to always call next()!
  }
});



export default router;